import {
  DashboardOrderDetailsResponse,
  DashboardSystemCurrentTimeResponse,
} from "@/shared/api";
import { OverallProgress } from "./overall-progress";
import { Box, Flex, Skeleton } from "@radix-ui/themes";

type PinBasedPredictionProgressProps = {
  data?: DashboardSystemCurrentTimeResponse;
  isLoading: boolean;
  journeyCount: number | undefined;
  orderDetails?: DashboardOrderDetailsResponse["result"];
};

export function PinBasedPredictionProgress({
  data,
  isLoading,
  journeyCount,
  orderDetails,
}: PinBasedPredictionProgressProps) {
  if (isLoading) {
    return (
      <Box mr="2" height="82px">
        <Skeleton
          width="150px"
          height="24px"
          className="rounded-base"
        ></Skeleton>
        <Skeleton height="8px" my="1" className="rounded-full"></Skeleton>
        <Flex justify="between" gap="2">
          <Box className="space-y-1">
            <Skeleton
              height="14px"
              width="76px"
              className="rounded-md"
            ></Skeleton>
            <Skeleton
              height="14px"
              width="120px"
              className="rounded-md"
            ></Skeleton>
          </Box>
          <Flex direction="column" gap="1" align="end">
            <Skeleton
              height="14px"
              width="72px"
              className="rounded-md"
            ></Skeleton>
            <Skeleton
              height="14px"
              width="120px"
              className="rounded-md"
            ></Skeleton>
          </Flex>
        </Flex>
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <OverallProgress
      data={data.result}
      hasJourneysCreated={journeyCount !== undefined && journeyCount > 0}
      finalizedAtTitle="Last Journey Exit time"
      orderTime={orderDetails?.order.time}
      isCompleted={orderDetails?.pin_based_prediction_cart !== null}
    />
  );
}
